import { FORM_INPUTS } from "./formInputs";
import { availableCountriesStates } from "./state";

const deleteExistingSelectOptions = (element) => {
    const options = element.querySelectorAll("option:not([disabled])");

    for (let i = 0; i < options.length; i++) {
        element.removeChild(options[i]);
    }
}

export const createMonthOptions = () => {
    if (!FORM_INPUTS.monthExpiry.element) return

    deleteExistingSelectOptions(FORM_INPUTS.monthExpiry.element);

    for (let i = 1; i <= 12; i++) {
        const option = document.createElement('option');
        let month = i;
        if (i < 10) {
            month = '0' + i;
        }
        option.value = option.innerHTML = month;
        FORM_INPUTS.monthExpiry.element.appendChild(option);
    }
};

export const createYearOptions = () => {
    if(!FORM_INPUTS.yearExpiry.element) return

    deleteExistingSelectOptions(FORM_INPUTS.yearExpiry.element);

    const getDate = new Date();
    const currentYear = getDate.getFullYear();

    for (let i = currentYear; i <= currentYear + 10; i++) {
        const option = document.createElement('option');
        option.value = option.innerHTML = i;
        FORM_INPUTS.yearExpiry.element.appendChild(option);
    }
};

export const createStateOptions = (country) => {
    if (!availableCountriesStates.includes(country) || !FORM_INPUTS.state.element || FORM_INPUTS.state.element.tagName !== 'SELECT') {
        return
    }

    deleteExistingSelectOptions(FORM_INPUTS.state.element);

    if (FORM_INPUTS.state.element.querySelectorAll("option:is([disabled])").length === 0) {
        createSelectPlaceholderForState(FORM_INPUTS.state.element);
    }

    import("./state").then(res => {
        const countryState = res[`${country.toUpperCase()}_STATES_LIST`];

        countryState.map(item => {
            const option = document.createElement('option');
            option.value = item.value;
            option.innerHTML = item.name;

            FORM_INPUTS.state.element.appendChild(option);
        })
    })
}

const createSelectPlaceholderForState = (element) => {
    const option = document.createElement('option');
    option.value = '';
    option.disabled = true;
    option.selected = true;

    if (!document.querySelector(`label[for='state']`)) {
        option.setAttribute('lng-tag', 'state')
        option.setAttribute('lng-cty-tag', 'state')
    }

    element.appendChild(option);
}

export const deleteStateSelectIfOptionsNotExists = () => {
    if (FORM_INPUTS.state.element && FORM_INPUTS.state.element.tagName === 'SELECT' && FORM_INPUTS.state.element.options.length === 0) {
        FORM_INPUTS.state.element.remove();

        const stateLabel = document.querySelector(`label[for='state']`);
        if (stateLabel) {
            stateLabel.remove();
        }

        const stateInputWrapper = document.querySelector('.state-input-wrapper');
        if (stateInputWrapper) {
            stateInputWrapper.remove();
        }
    }
}
